import React from 'react';

const FormInput = ({ 
  label, 
  type, 
  name, 
  value, 
  onChange, 
  placeholder,
  error,
  required = false
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && '*'}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={`w-full px-3 py-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent ${
          error ? 'border-leadme-red' : 'border-gray-300'
        }`}
      />
      {error && (
        <p className="mt-1 text-sm text-leadme-red">{error}</p>
      )}
    </div>
  );
};

export default FormInput;
